// extracted by mini-css-extract-plugin
export default {"detailsButton":"detailsButton---goCDA"};